import React from "react";
import { DoctorLogin } from "../components/Doctors/DoctorLogin";
const DoctorLoginPage = () => {
  return (
    <div>
      <DoctorLogin />
    </div>
  );
};

export default DoctorLoginPage;
